<template>
  <div class="row myrow content-mb-42" v-if="$parent.$parent.rerender">
    <div class="">
      <div
        class="form-group"
        v-bind:class="{
          'has-error': $parent.$parent.checkErrorField(
            'PROJECTS',
            'LOGIC',
            'UF_LIST_PRODUCTS_NACIONAL_PROJECTS_ID_ARR'
          )
        }"
      >
        <div class="info-holder-container">
          <Multiselect
            label="LABEL"
            class="i-main-style i-wid-50 stl-bs_bb multiselect-filter-project-register multiselect-multiline"
            :limit="10"
            :limitText="filterItemText"
            track-by="ID"
            v-model="project.UF_LIST_PRODUCTS_NACIONAL_PROJECTS_ID_ARR"
            :options="getListProductsNacionalProjects()"
            :multiple="true"
            placeholder="Начните вводить название или код продукции"
          >
            <span slot="noResult">Записи не найдены</span>
          </Multiselect>
        </div>
      </div>
      <div class="error-text">
        {{
          $parent.$parent.checkErrorText(
            "PROJECTS",
            "LOGIC",
            "UF_LIST_PRODUCTS_NACIONAL_PROJECTS_ID_ARR"
          )
        }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Multiselect from "vue-multiselect";

export default {
  name: "uf_list_products_nacional_projects",
  computed: {
    ...mapGetters(["directory", "project"])
  },
  components: {
    Multiselect
  },
  methods: {
    filterItemText(count) {
      console.log(count);
      return ``;
    },
    inArray(needle, haystack) {
      var length = haystack.length;
      for (var i = 0; i < length; i++) {
        if (haystack[i] == needle) return true;
      }
      return false;
    },
    getListProductsNacionalProjects() {
      let version =
        ( this.$parent.project.UF_SETTING.VERSION_LIST_PRODUCT_NACIONAL_PROJECTS &&
          parseInt(this.$parent.project.UF_SETTING.VERSION_LIST_PRODUCT_NACIONAL_PROJECTS) > 0
        )
          ? parseInt(this.$parent.project.UF_SETTING.VERSION_LIST_PRODUCT_NACIONAL_PROJECTS)
          : 1;

      let t = this.$parent.directory.sp_list_products_nacional_projects.filter(el =>
          el.VERSIONS.includes(version)
      );
      if (t.length > 0) {
        return t;
      }

      return [];


    }
  }
};
</script>

<style scoped></style>
